import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

const styles = {
  card: {
    borderRadius: '10px',
    padding: '2rem 2rem 1.6rem 2rem',
    width: '13.6rem',
    textAlign: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'grid',
    gridTemplateRows: '4rem auto',
    justifyItems: 'center',
    boxShadow: 'rgba(0, 0, 0, 0.10) 0rem 0.4rem 0.8rem 0px',
  },
  defaultCard: { color: colors.blue[600], backgroundColor: colors.blue[100] },
  cardTitle: {
    font: { size: '1.2rem', lineHeight: '1.8rem', weight: 700 },
    letterSpacing: '0.03rem',
    textTransform: 'uppercase',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };

export const CardStyled = styled.li`
  border-radius: 1rem;
  padding: 2rem 2rem 1.6rem;
  width: 13.6rem;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  grid-template-rows: 4rem auto;
  justify-items: center;
  box-shadow: rgb(0 0 0 / 10%) 0 0.4rem 0.8rem 0;
  color: ${colors.blue[600]};
  background-color: ${colors.blue[100]};
`;

export const CardTitleStyled = styled.h3`
  font-size: 1.2rem;
  line-height: 1.8rem;
  font-weight: 700;
  letter-spacing: 0.03rem;
  text-transform: uppercase;
`;
